import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

const data = [
  { luna: "Ian", venituri: 4000, cheltuieli: 2400 },
  { luna: "Feb", venituri: 3000, cheltuieli: 1398 },
  { luna: "Mar", venituri: 2000, cheltuieli: 9800 }
];

const RaportFinanciar = () => (
  <div className="dashboard-container-rapoarte">
        <section className="grafice-rapoarte">
      <div className="chart-card" id="raport-social-chart" >
    <h2> Raport Financiar</h2>
      <BarChart width={500} height={300} data={data} className="bar-chart">
        <CartesianGrid strokeDasharray="3 3" className="cartesian-grid" />
        <XAxis dataKey="luna" className="x-axis" />
        <YAxis className="y-axis" />
        <Tooltip className="tooltip" />
        <Legend className="legend" />
        <Bar dataKey="venituri" fill="#82ca9d" className="bar venituri-bar" />
        <Bar dataKey="cheltuieli" fill="#8884d8" className="bar cheltuieli-bar" />
      </BarChart>
      </div>
      </section>
    </div>
);

export default RaportFinanciar;
